import { IntlShape, defineMessages } from 'react-intl'
import * as yup from 'yup'

import { IPlaceCoordinatesForm } from 'features/Places/types'
import { LATITUDE_REGEX_STRING, LONGITUDE_REGEX_STRING } from 'utils/google-maps'

const coordinatesMessages = defineMessages({
  requiredLat: {
    id: 'places.new.form.latitude.required',
    defaultMessage: 'The latitude is required'
  },
  requiredLng: {
    id: 'places.new.form.longitude.required',
    defaultMessage: 'The longitude is required'
  },
  formatLat: {
    id: 'places.new.form.latitude.format',
    defaultMessage: 'The latitude format is wrong'
  },
  formatLng: {
    id: 'places.new.form.longitude.format',
    defaultMessage: 'The longitude format is wrong'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IPlaceCoordinatesForm> => {
  return yup.object().shape({
    coordinates: yup.object().shape({
      latitude: yup
        .string()
        .matches(new RegExp(LATITUDE_REGEX_STRING), intl.formatMessage(coordinatesMessages.formatLat))
        .required(intl.formatMessage(coordinatesMessages.requiredLat)),
      longitude: yup
        .string()
        .matches(new RegExp(LONGITUDE_REGEX_STRING), intl.formatMessage(coordinatesMessages.formatLng))
        .required(intl.formatMessage(coordinatesMessages.requiredLng))
    }),
    geofenceRadius: yup.number().nullable()
  })
}
